import env from 'config';
import LogRocket from 'logrocket';
import { createContext, FC, useEffect, useState } from 'react';
import { useAuthStore } from 'stores/use-auth-store';

const APP_ID = 's9iwvp/trajekt';

export interface ILogRocketContext {}

const DEFAULT: ILogRocketContext = {};

export const LogRocketContext = createContext(DEFAULT);

/** for tracking misc details across entire app */
export const LogRocketProvider: FC = () => {
  const current = useAuthStore((s) => s.current);

  const [init, setInit] = useState(false);

  const state: ILogRocketContext = {};

  useEffect(() => {
    if (!current.auth) {
      return;
    }

    if (init) {
      LogRocket.startNewSession();
    } else {
      LogRocket.init(APP_ID, {
        release: `${env.version} @ ${env.getBuildStamp()}`,
      });

      setInit(true);
    }

    LogRocket.identify(current.email, {
      env: env.identifier,
      session: current.session,
      teamID: current.teamID,
      teamName: current.team,
    });
  }, [
    current.auth,
    current.session,
    current.email,
    current.teamID,
    current.team,
  ]);

  return <LogRocketContext.Provider value={state} />;
};
